@if (!skeletonView) {
  @if (order.storehouseId) {
    <app-chip>
      {{ order.storehouseName || ('COLUMNS.no_storehouse' | translate) }}
    </app-chip>
  } @else {
    <span class="muted">{{ 'ORDERS.COMMON.UNLOADING.no_storehouse' | translate }}</span>
  }
} @else {
  <ngx-skeleton-loader [count]="1" [theme]="{
    height: '30px',
    minWidth: '100px',
    borderRadius: '50px'
    }">
  </ngx-skeleton-loader>
}
